import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button/Button';

function SearchProgressModalFooter(props) {
  const { cancelSearch } = props;

  return (
    <div className="search-modal__footer" data-testid="search-modal-footer">
      <Button
        name="cancel-search"
        buttonConfig={{
          type: 'link',
          size: 'sm',
          label: 'Cancel',
          e2eName: 'modal-search-cancel',
        }}
        iconConfig={{ name: 'delete', size: 'sm' }}
        onClick={cancelSearch}
      />
    </div>
  );
}

SearchProgressModalFooter.propTypes = {
  cancelSearch: PropTypes.func.isRequired,
};

export default SearchProgressModalFooter;
